import { axios } from '@/services/axios';

const getCarriers = async (currentScope) => {
    const res = await axios.get('/Carriers', {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default getCarriers;
